import { Extent } from './Extent';
import { Polygon } from './Polygon';

export class Circle {
  private center: [number, number];
  private radius: number;
  private srid: string;

  constructor(center: [number, number], radius: number, srid: string = 'EPSG:4326') {
    this.center = [...center];
    this.radius = radius;
    this.srid = srid;
  }

  getCenter(): [number, number] {
    return [...this.center];
  }

  setCenter(center: [number, number]): void {
    this.center = [...center];
  }

  getRadius(): number {
    return this.radius;
  }

  setRadius(radius: number): void {
    this.radius = radius;
  }

  toPolygon(segments: number = 64): Polygon {
    const coords: [number, number][] = [];
    for (let i = 0; i <= segments; i++) {
      const angle = (2 * Math.PI * i) / segments;
      coords.push([
        this.center[0] + this.radius * Math.cos(angle),
        this.center[1] + this.radius * Math.sin(angle),
      ]);
    }
    return new Polygon([coords], this.srid);
  }

  containsPoint(point: [number, number]): boolean {
    const dx = point[0] - this.center[0];
    const dy = point[1] - this.center[1];
    return Math.sqrt(dx * dx + dy * dy) <= this.radius;
  }

  getExtent(): Extent {
    return new Extent(
      this.center[0] - this.radius,
      this.center[1] - this.radius,
      this.center[0] + this.radius,
      this.center[1] + this.radius
    );
  }

  clone(): Circle {
    return new Circle([...this.center], this.radius, this.srid);
  }
}
